<template>
  <div class="iv-nav">
    <div class="iv-nav-list iv-pull-right">
      <ul>
        <router-link tag="li"
          :class="($route.path == item.router || currentName === item.title) ? 'activeLi' : ''"
          class="iv-fc-65 iv-pull-left iv-nav-li uit-click-list"
          v-for="(item, index) in navList"
          @click.native="listClick(item)"
          :key="index"
          :to="item.router">
          {{item.title}}
        </router-link>
      </ul>
    </div>
  </div>
</template>

<script>
import nav from './nav.conf'

export default {
  data () {
    return {
      navList: [],
      currentName: ''
    }
  },
  created () {
    this.navList = nav
  },
  methods: {
    //点击导航
    listClick (item) {
      //后期路由全部配置完毕后可去除
      let lis = this.$el.querySelectorAll('.iv-nav-li')
      lis.forEach(v => {
        v.classList.remove('activeLi')
      })
      this.currentName = item.title
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../static/lib/css/base/variable.scss';
.iv-nav {
  width: 1176px;
  height: 72px;
  margin: 0 auto;
  background: #fff;
  line-height: 72px;
  position: relative;
  .iv-logo {
    img {
      width: 189px;
      height: 36px;
      vertical-align: middle;
    }
  }
  .iv-nav-list {
    position: absolute;
    right: 0;
    top: 50%;
    margin-top: -20px;
    ul {
      li {
        width: 112px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        text-align: center;
        cursor: pointer;
      }
      li:hover {
        color: $iv-main-color !important;
        background-color: $iv-main-li-bg-color;
        border-radius: 20px;
      }
      .activeLi {
        color: $iv-main-color !important;
        background-color: $iv-main-li-bg-color;
        border-radius: 20px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/header/nav.vue